import { Component } from '@angular/core';
import {environment} from "../../../../environments/environment";
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {
  constructor(private router: Router, private auth: AuthService) {}
  logout() {
    // Ends the Cognito session as well; clearing local tokens alone would sign straight back in
    // on the next redirect. Cognito returns the browser to the configured post-logout URL.
    this.auth.logout();
  }
  protected readonly environment = environment;
}
